<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 4H19C19.0929 4 19.1839 4.02586 19.2629 4.07467C19.3419 4.12349 19.4057 4.19334 19.4472 4.27639C19.4887 4.35945 19.5063 4.45242 19.498 4.5449C19.4896 4.63738 19.4557 4.72572 19.4 4.8L14 12V20.191C14 20.2763 13.9782 20.3601 13.9367 20.4346C13.8951 20.509 13.8352 20.5716 13.7627 20.6164C13.6901 20.6612 13.6073 20.6867 13.5221 20.6905C13.437 20.6943 13.3522 20.6762 13.276 20.638L10 19V12L4.6 4.8C4.54429 4.72572 4.51036 4.63738 4.50202 4.5449C4.49368 4.45242 4.51126 4.35945 4.55279 4.27639C4.59431 4.19334 4.65815 4.12349 4.73713 4.07467C4.81612 4.02586 4.90714 4 5 4Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
import { type CbIconProps, cbIconDefaults } from "../cb-icon.props";

withDefaults(defineProps<CbIconProps>(), cbIconDefaults);
</script>
